import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  styled,
} from '@mui/material';

export const HeaderStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasMarginBottom',
})(({ theme, hasMarginBottom }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: hasMarginBottom && '8px',
  width: '344px',
  [theme.breakpoints.up('md')]: {
    width: '603px',
  },
}));

export const ListStyled = styled(List)(() => ({
  padding: 0,
}));

export const CloseIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '20px',
  color: theme.palette.colors.label,
  cursor: 'pointer',
  paddingRight: '8px',
  [theme.breakpoints.up('md')]: {
    paddingRight: '22px',
  },
}));

export const ListItemStyled = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'noTopRadius',
})(({ theme, noTopRadius }) => ({
  width: '344px',
  height: '32px',
  backgroundColor: theme.palette.colors.primaryBackground,
  justifyContent: 'space-between',
  padding: '0 8px',
  '&:first-of-type': {
    borderTopLeftRadius: !noTopRadius && '5px',
    borderTopRightRadius: !noTopRadius && '5px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  '&:not(:last-of-type)': {
    marginBottom: '1px',
  },
  [theme.breakpoints.up('md')]: {
    width: '603px',
    padding: '0 22px',
  },
}));

export const AccordionsWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  paddingBottom: '23px',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
}));

export const AccordionStyled = styled(Accordion)(({ theme }) => ({
  width: '344px',
  backgroundColor: 'transparent',
  boxShadow: 'none',
  '&::before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
    '&::before': {
      display: 'none',
    },
  },
  [theme.breakpoints.up('md')]: {
    width: '603px',
  },
}));

export const AccordionSummaryStyled = styled(AccordionSummary)(({ theme }) => ({
  height: '32px',
  minHeight: '32px',
  padding: '0 8px',
  backgroundColor: theme.palette.colors.primaryBackground,
  borderRadius: '5px',

  '&.Mui-expanded': {
    height: '32px',
    minHeight: '32px',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  '& .MuiAccordionSummary-content': {
    width: '90%',
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
    [theme.breakpoints.up('md')]: {
      width: '66%',
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    width: '10%',
    display: 'flex',
    justifyContent: 'flex-end',
    '& svg': {
      transform: 'rotate(0deg)',
      transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    '&.Mui-expanded': {
      transform: 'none',
      transition: 'none',

      '& svg': {
        transform: 'rotate(180deg)',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
    },
    [theme.breakpoints.up('md')]: {
      width: '33%',
    },
  },
  [theme.breakpoints.up('md')]: {
    padding: '0 22px',
  },
}));

export const AccordionDetailsStyled = styled(AccordionDetails)(() => ({
  padding: 0,
  marginTop: '1px',
}));

export const ArrowIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.colors.mainFocused,
}));

export const SummaryItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'nElements',
})(({ nElements }) => ({
  width: '50%',
  '&:last-of-type': {
    display: 'flex',
    justifyContent: nElements > 1 && 'center',
  },
}));
